import { render, staticRenderFns } from "./CreateAdvertiser.vue?vue&type=template&id=2edb2d47"
import script from "./CreateAdvertiser.vue?vue&type=script&lang=js"
export * from "./CreateAdvertiser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports